<template>
  <div>
    <v-text-field
      :label="$t(label)"
      clearable
      readonly
      prepend-inner-icon="fas fa-paperclip"
      @click="onAddFileClick"
      @click:prepend-inner="onAddFileClick"
      @click:clear="onClear"
      ref="textField"
      :value="fileName"
    >

    </v-text-field>
    <input
      type="file"
      :name="name"
      :accept="accept"
      :multiple="multiple"
      @input="onInput"
      ref="fileInput"
      style="display: none;"
    />
  </div>
</template>

<script>
export default {
  name: 'FileField',
  props: {
    id: String,
    name: String,
    label: [Object, String],
    accept: String,
    multiple: Boolean
  },
  data() {
    return {
      fileName: '',
      files: [],
    }
  },
  methods: {

    onAddFileClick() {
      this.$refs.fileInput.click();
    },

    onClear() {
      this.fileName = ''
      this.$refs.fileInput.value = ''
      this.files = []
      this.$emit('input', [])
    },

    onInput(e) {
      this.files = (this.files || []).concat(this.$refs.fileInput.files ? [...this.$refs.fileInput.files] : []);
      const res = this.readFiles(this.files)
      this.fileName = res[0] ? res[0].name || '' : '';
      this.$emit('input', res)
    },

    readFiles(fileList) {
      const res = [];
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        res.push({
          name: file.name,
          type: file.type,
          data: file
        })
      }
      return res;
    },

  }
}
</script>

<style>

</style>